import { Link } from "react-router-dom";
import heroImage from "../../public_html/assets/images/hero-beauty.svg";
import editorialImage from "../../public_html/assets/images/category-moisture.svg";
import { CategoryCard } from "../components/Cards";
import { DeliveryNotice } from "../components/DeliveryNotice";
import { Meta } from "../components/Meta";
import { routes } from "../config/routes";
import { categories } from "../data/catalogue";

export function HomePage() {
  return (
    <main id="main">
      <Meta
        title="Beautify Ourselves | Beauty, chosen with care"
        description="Discover the future home of thoughtfully selected beauty essentials from Beautify Ourselves."
        path="/"
      />
      <section className="hero">
        <div className="hero-copy">
          <p className="eyebrow">A more considered beauty shop</p>
          <h1>
            Beauty should feel <em>clear, personal,</em> and yours.
          </h1>
          <p className="lead">
            We’re preparing a collection of beauty essentials chosen with care, with clear
            product information and no inflated promises.
          </p>
          <div className="hero-actions">
            <Link className="button" to={routes.shop}>
              Explore the collection
            </Link>
            <Link className="button button-secondary" to={routes.about}>
              Our approach
            </Link>
          </div>
        </div>
        <div className="hero-art">
          <img
            src={heroImage}
            alt="Abstract beauty still life in warm rose tones"
            width="900"
            height="1100"
          />
        </div>
      </section>

      <DeliveryNotice variant="strip" />

      <section className="section" aria-labelledby="categories-heading">
        <div className="section-inner">
          <div className="section-heading">
            <div>
              <p className="eyebrow">Browse the future collection</p>
              <h2 id="categories-heading">Everyday care, thoughtfully presented.</h2>
            </div>
            <p>
              The first collection is being prepared, with clear descriptions, ingredient
              information and practical guidance alongside each product.
            </p>
          </div>
          <div className="category-grid">
            {categories.map((category) => (
              <CategoryCard key={category.id} category={category} />
            ))}
          </div>
        </div>
      </section>

      <section className="section steps" aria-labelledby="collection-heading">
        <div className="section-inner">
          <p className="eyebrow">The future collection</p>
          <h2 id="collection-heading">Beauty choices, made clearer.</h2>
          <div className="steps-grid">
            <article className="step">
              <h3>Clear details</h3>
              <p>Useful product information designed to help you choose with confidence.</p>
            </article>
            <article className="step">
              <h3>Considered categories</h3>
              <p>
                Cleansers, moisturisers and body care brought together in one calm
                collection.
              </p>
            </article>
            <article className="step">
              <h3>Practical guidance</h3>
              <p>Simple information on ingredients, use and delivery alongside each product.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="editorial">
        <div className="editorial-image">
          <img
            src={editorialImage}
            alt="Abstract still life in soft green and cream"
            width="600"
            height="800"
          />
        </div>
        <div className="editorial-copy">
          <p className="eyebrow">Why we’re taking our time</p>
          <h2>A smaller edit. Better information.</h2>
          <p className="lead">
            The first Beautify Ourselves collection is being carefully prepared with clear
            product information and a considered point of view.
          </p>
          <p>
            For now, explore the categories and discover the warm, straightforward shopping
            experience we’re creating.
          </p>
          <Link className="text-link" to={routes.about}>
            Read about our approach <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
    </main>
  );
}
